import { includes, reduce } from 'libraries/lodash'
import {
  USER_PRECEDENTS_EDITOR,
  USER_LITE,
  USER_PREMIUM,
  USER_CLARILIS,
  USER_CLARILIS_SHARES,
  USER_DOC_DRAFTER_CORP,
  USER_DOC_DRAFTER_EMP
} from 'constants/user-roles'
import {
  SET_USER_DETAILS,
  SET_USER_IS_LOGGED,
  SET_USER_ROLES,
  SET_USER_IS_ADMIN,
  SET_USER_IS_CORE,
  SET_USER_IS_CLARILIS,
  SET_USER_IS_LIMITED_ACCESS,
  SET_USER_ENCRYPTION_KEYS_LOADED,
  SET_USER_IS_DOCDRAFTER
} from './types'
import { AppDispatch, RootState } from 'redux/store';

export const setUserDetails = (details: {email:string; isExternalAuth: boolean}) => ({
  type: SET_USER_DETAILS,
  details
})

export const setUserIsLogged = (isLogged: boolean) => ({
  type: SET_USER_IS_LOGGED,
  isLogged
})

export const isRoles = (state: RootState, ...props:string[]) => {
  return props.length !== 0 ? reduce(
    props,
    (result, role) => result && includes(state.user.roles, role),
    true
  ) : true
}


export const isOneOfRoles = (state: RootState, ...roles:string[]) => {
  return roles.length !== 0 ? reduce(
    roles,
    (result, role) => result || includes(state.user.roles, role),
    false
  ) : false
}

export const setUserRoles = (roles:string[]) => {
  return (dispatch:AppDispatch, getState: () => RootState) => {
    dispatch({
      type: SET_USER_ROLES,
      roles
    })

    const state = getState()

    const isAdmin = isRoles(state, USER_PRECEDENTS_EDITOR)
    dispatch({
      type: SET_USER_IS_ADMIN,
      isAdmin
    })

    const isCore = isRoles(state, USER_LITE) && !isRoles(state, USER_PREMIUM)
    dispatch({
      type: SET_USER_IS_CORE,
      isCore
    })

    const isClarilis = isOneOfRoles(state, USER_CLARILIS, USER_CLARILIS_SHARES)
    dispatch({
      type: SET_USER_IS_CLARILIS,
      isClarilis
    })

    const isDocDrafter = isOneOfRoles(state, USER_DOC_DRAFTER_CORP, USER_DOC_DRAFTER_EMP)
    dispatch({
      type: SET_USER_IS_DOCDRAFTER,
      isDocDrafter
    })

    const isLimitedAccess = !isRoles(state, USER_PREMIUM)
    dispatch({
      type: SET_USER_IS_LIMITED_ACCESS,
      isLimitedAccess
    })
  }
}

export const setUserEncryptionKeysLoaded = (encryptionKeysLoaded: boolean) => ({
  type: SET_USER_ENCRYPTION_KEYS_LOADED,
  encryptionKeysLoaded
})
